<template>
  <div class="product-card">
    <div v-if="qualification && qualification.quantity > 0">
      <NsProductCard
        :sku="productId"
        class="qualifications-product-card"
        hide-favorites="true"
        hide-sku="true"
        hide-exclusive-icon="true"
        forcesv="false"
        show-action="true"
        >
          <div class="available-quantity">
            <div class="number-available">
                {{ qualification.quantity }}
            </div>
            <span>{{ tdc.tdc_reservedForYou }}</span>
          </div>
      </NsProductCard>
    </div>
  </div>
</template>

<script>
import { NsProductCard } from '@nuskin/product-components'

import { productLib } from '@nuskin/product-lib'
import {
  RunConfigService
} from '@nuskin/ns-util'

import { events } from '@nuskin/ns-util'

export default {
  components: {
    NsProductCard,
  },
  props: {
    qualification: Array,
    tdc: Object,
  },
  data() {
    return {
      productId: null
    }
  },
  mounted() {
    events.subscribe(events.shop.ADD_TO_CART, (event) => {
      if (event.sku === this.qualification.productId) {
        events.publish(events.shop.SHOW_EXCLUSIVE_OFFER_DETAILS, {
          sku: this.qualification.productId
        })
      }
    })
    this.setupProductId()
  },
  unmounted() {
    events.unsubscribe(events.shop.ADD_TO_CART)
  },
  methods: {
    async setupProductId() {
      if (this.qualification && this.qualification.quantity > 0) {
        // this is a temporary work around
        // to help the product card understand product ids
        let {
          country,
          language,
          envCode
        } = RunConfigService.getRunConfig()
        if ((country || '').toLowerCase() == 'id' && (language || '').toLowerCase() == 'in') {
          language = 'id'
        }
        const product = await productLib.getProduct({
          fromId: this.qualification.productId,
          market: country,
          language,
          env: envCode,
          useContentSource: 'CS'
        })

        this.productId = (product.data.variants[0] || { sku: product.data.id}).sku
      }
    }
  }
}
</script>

<style lang="scss">

  .qualifications-product-card {
    box-shadow: rgb(0 0 0 / 15%) 0 8px 8px 0;
  }

  .available-quantity {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 22px;
    padding-top: 30px;

    .number-available {
      width: 38px;
      height: 35px;
      border-radius: 20px;

      justify-content: center;
      background-color: #bb29bb;
      color: white;
      margin-right: 20px;
      display: flex;
      align-items: center;
      font-weight: 700;
    }

    span {
      max-width: 200px;
    }
  }
</style>
